import React from 'react';
import { Link } from 'react-router-dom';
import { SquareIcon } from 'lucide-react';
import { useTimer } from '../../../contexts/TimerContext';
import { useNow } from '../../../hooks/useNow';
import { formatElapsed } from '../../../utils/timer';

/** Fast bjælke øverst på alle admin-sider, så længe en timer kører. Kan ikke lukkes væk. */
export function TimerBar() {
  const {
    timer,
    requestStop
  } = useTimer();
  const now = useNow(Boolean(timer));
  if (!timer) return null;
  const elapsed = formatElapsed(now - new Date(timer.startedAt).getTime());
  return <div role="status" aria-label="Aktiv timer" className="bg-accent text-white" data-id="element-633" data-mp="12y4kiffaygne">
      <div className="flex h-12 items-center gap-3 px-4 md:px-8" data-id="element-634" data-mp="xzb34bwwa5hy">
        <p className="flex min-w-0 flex-1 items-center gap-2 text-sm" data-id="element-635" data-mp="t0zshyyrzqyo">
          <span className="hidden shrink-0 font-semibold sm:inline" data-id="element-636" data-mp="3ir3hbzkn4ws1">Aktiv timer</span>
          <span className="hidden opacity-60 sm:inline" aria-hidden="true" data-id="element-637" data-mp="3dsa13zdyyro6">•</span>
          <span className="truncate" data-id="element-638" data-mp="3dud2tgohi98q">{timer.caseTitle || 'Sag'}</span>
          <span className="opacity-60" aria-hidden="true" data-id="element-639" data-mp="2klz6w0jmqip4">•</span>
          <span className="shrink-0 font-semibold tabular-nums" data-id="element-640" data-mp="2omrjn3rpn5q5">{elapsed}</span>
        </p>
        <Link to={`/admin/sager/${timer.caseId}`} className="hidden h-9 shrink-0 items-center rounded-full px-3 text-sm font-medium transition-colors duration-150 hover:bg-black/10 sm:inline-flex" data-id="element-641" data-mp="2amqgtirvxo81">
          Åbn sag
        </Link>
        <button type="button" onClick={requestStop} className="inline-flex h-9 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-black/15 px-3.5 text-sm font-semibold transition-colors duration-150 hover:bg-black/25" data-id="element-642" data-mp="20vdraxtk7a56">
          <SquareIcon className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-643" data-mp="1ww4u1izb8u4v" />
          Stop timer
        </button>
      </div>
    </div>;
}